import { ConfigurationSchema } from '@jbrowse/core/configuration'
const configSchema = ConfigurationSchema('HierarchicalTrackSelectorWidget', {})
export default configSchema
